import {Observable} from 'rxjs';
import {Inject, Injectable} from '@angular/core';

import {ProductPort} from '@features/product/application/ports/product.port';
import {ListProductUseCasePort} from '@features/product/application/use_cases/list-product/list-product.use-case.port';

import {ListProductResponseDto} from '@features/product/application/use_cases/list-product/dto/list-product.response.dto';
import {ListProductPayloadDto} from '@features/product/application/use_cases/list-product/dto/list-product.payload.dto';

@Injectable()
export class ListProductUseCase implements ListProductUseCasePort {

  constructor(
    @Inject(ProductPort)
    private readonly port: ProductPort
  ) {
  }

  public execute(payload: ListProductPayloadDto): Observable<ListProductResponseDto> {
    return this.port.listProduct(payload);
  }
}
